export default "__VITE_ASSET__DbO2GUuK__"